class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.searchFormListenersBound = false;
    this.inputTimeout = null;
    this._handleSearchInput = this.onInput.bind(this);
    this._handleFormReset = this.onFormReset.bind(this);
    this._handleFormSubmit = this.onFormSubmit.bind(this);
  }

  connectedCallback() {
    this.input = this.querySelector('input[type="search"]');
    this.form = this.input?.form || this.querySelector('form[role="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (!this.input || !this.form || this.searchFormListenersBound) return;

    this.input.addEventListener('input', this._handleSearchInput);
    this.form.addEventListener('reset', this._handleFormReset);
    this.form.addEventListener('submit', this._handleFormSubmit);
    this.searchFormListenersBound = true;
    this.toggleResetButton();
  }

  disconnectedCallback() {
    this.cancelPendingChange();
    if (this.searchFormListenersBound) {
      this.input?.removeEventListener('input', this._handleSearchInput);
      this.form?.removeEventListener('reset', this._handleFormReset);
      this.form?.removeEventListener('submit', this._handleFormSubmit);
    }

    this.searchFormListenersBound = false;
    this.input = null;
    this.form = null;
    this.resetButton = null;
  }

  getQuery() {
    return this.input?.value.trim() || '';
  }

  onInput() {
    this.toggleResetButton();
    this.cancelPendingChange();
    this.inputTimeout = setTimeout(() => {
      this.inputTimeout = null;
      this.onChange();
    }, 300);
  }

  cancelPendingChange() {
    clearTimeout(this.inputTimeout);
    this.inputTimeout = null;
  }

  toggleResetButton() {
    if (!this.resetButton || !this.input) return;

    const isEmpty = this.input.value.length === 0;
    this.resetButton.hidden = isEmpty;

    if (isEmpty) {
      this.resetButton.style.setProperty('display', 'none', 'important');
    } else {
      this.resetButton.style.removeProperty('display');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  onFormSubmit(event) {
    if (!this.getQuery().length) event.preventDefault();
  }

  onFormReset(event) {
    event.preventDefault();
    this.cancelPendingChange();

    if (!this.input) return;

    this.input.value = '';
    this.toggleResetButton();
    this.input.focus();
  }
}

if (!customElements.get('search-form')) {
  customElements.define('search-form', SearchForm);
}
